// Words the artist may swap: the Feeling Wall's invitation (one picked per visit) and its quiet guided-tour line
export const HALL_PROMPTS = [
  "Follow the feeling that finds you",
  "Which door is your heart drawn to?",
  "Step through the door that speaks to you",
  "Choose the door that calls to you",
];
export const HALL_GUIDE_LINE = "or let the gallery guide you ›";
export const FLIPBOOK_ENDING = "Take the stories with you, open The Flipbook ›";

const KEY = "afae-hall-prompt";
export function hallPrompt() {
  const saved = HALL_PROMPTS[sessionStorage.getItem(KEY)];
  if (saved) return saved;
  const i = Math.floor(Math.random() * HALL_PROMPTS.length);
  sessionStorage.setItem(KEY, String(i));
  return HALL_PROMPTS[i];
}
